import React from 'react';
import './index.scss';
import { useSelector } from 'react-redux';
import { RootState } from '@/redux/store';
import { HttpStatusCode } from '@/fetch/core/constant';
import { message } from 'antd';
import classNames from 'classnames';
import CollectMapApi from '@/fetch/bussiness/collectMap';
import { SystemStateEnum } from '@/utils/constant';
const fetchApi = new CollectMapApi();
const EnterCollectMap = (props: {
  vehicleName: string;
  cockpitNumber: string;
  systemState: any;
  onClose: any;
}) => {
  const { login } = useSelector((state: RootState) => state);
  const { cockpitNumber, vehicleName, onClose } = props;
  const enterCollectMap = async () => {
    try {
      if (!login.userInfo?.userName || !cockpitNumber || !vehicleName) {
        return;
      }
      const res = await fetchApi.switchMode({
        cockpitNumber,
        vehicleName,
        operateTime: new Date().getTime(),
        action: 1,
      });
      if (res.code === HttpStatusCode.Success) {
        message.success(
          `${vehicleName}车辆模式将切换为采图模式，预计等待180秒`
        );
        onClose && onClose();
      } else {
        message.error(res.message || '网络请求错误');
        return;
      }
    } catch (e) {
      message.error(`${vehicleName}开启采图模式失败`);
      return;
    }
  };
  return (
    <>
      <li
        className={classNames('btn-item', {
          'enter-collect-map': props.systemState !== SystemStateEnum.OFFLINE,
          'enter-collect-map-disabled':
            !props.systemState || props.systemState === SystemStateEnum.OFFLINE,
        })}
        onClick={() => {
          if (!props.systemState) {
            return;
          }
          enterCollectMap();
        }}
      >
        <i>开启采图模式</i>
      </li>
    </>
  );
};

export default React.memo(EnterCollectMap);
